import React, { Component } from 'react';
import { connect } from 'react-redux';
import determinarPaginaAtual from '../../../actions/itinerario/determinarPaginaAtualRelatorioItinerarios';

import BotoesPaginacao from '../../comum/BotoesPaginacao';

export class SetasPaginacaoRelatorioItinerarios extends Component {
  render () {
    if (this.props.itinerarios.length === 0) {
      return '';
    }

    return <BotoesPaginacao
      numeroElementos={this.props.itinerarios.length}
      paginaAtual={this.props.paginaAtual}
      registrosPorPagina={this.props.registrosPorPagina}
      determinarPaginaAtual={this.props.determinarPaginaAtual}/>;
  }
}

export function mapStateToProps (state) {
  return {
    paginaAtual: state.paginaAtualRelatorioItinerarios,
    itinerarios: state.relatorioItinerarios,
    registrosPorPagina: state.registrosPorPaginaRelatorioItinerarios
  };
}

export default connect(mapStateToProps, { determinarPaginaAtual })(SetasPaginacaoRelatorioItinerarios);
